export { HighlightedCard as default } from './highlighted-card';
export * from './highlighted-card';
